<template>
  <div>

    <div class="mb-4">
      <div class="font-weight-bold">Describe your product/service</div>
      <div class="mt-2">POP AI will use this information to write more informed content about your product/service.</div>
    </div>

    <div>
      <div>
        <v-textarea
          outlined
          dense
          :value="productDescription"
          @input="$emit('update:productDescription', $event)"
          color="greenColor"
          counter="250"
          placeholder="Add description"
          :counter-value="countWords"
          :rules="[(v) => countWords(v) <= 250 || `Must be less than 250 words`]"
        >
        </v-textarea>
      </div>
    </div>

  </div>
</template>

<script>
export default {
    name: 'ConfigProductDescription',
    props: [
        'countWords',
        'productDescription',
    ],
    computed: {

    }
}
</script>

<style lang="scss" scoped>

</style>